import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

export const updatePickupDate = createAsyncThunk(
    'user/updatePickupDate',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/user/update-pickup-time`, payload);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to update pickup date');
        }
    },
);

export const updateDeliveryAddress = createAsyncThunk(
    'user/updateDeliveryAddress',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/user/update-delivery-address`, payload);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to update delivery address');
        }
    },
);

export const updateCreditCard = createAsyncThunk(
    'user/updateCreditCard',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/user/edit-credit-card`, payload);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to edit credit card.');
        }
    },
);
export const addCreditCard = createAsyncThunk(
    'user/addCreditCard',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/user/add-credit-card`, payload);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to add credit card.');
        }
    },
);

export const updatePaymentInformation = createAsyncThunk(
    'user/updatePaymentInformation',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/user/update-payment-information`, payload);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to add credit card.');
        }
    },
);
export const deleteCreditCard = createAsyncThunk(
    'user/deleteCreditCard',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/user/delete-credit-card`, payload);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to delete credit card.');
        }
    },
);

// Submit user feedback
export const submitFeedback = createAsyncThunk(
    'user/submitFeedback',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/feedback/create`, payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to submit feedback.');
        }
    },
);

